/**
 * Build information for debugging stale cache issues
 * This file is used to track build versions and detect stale content
 */

// Build timestamp - updated at build time via Vite define
export const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIME || new Date().toISOString();

// Simple build ID for quick comparison
export const BUILD_ID = BUILD_TIMESTAMP.slice(0, 19).replace(/[:-]/g, '');

/**
 * Get formatted build info for display
 */
export function getBuildInfo() {
  return {
    timestamp: BUILD_TIMESTAMP,
    id: BUILD_ID,
    environment: import.meta.env.MODE,
  };
}

/**
 * Log build info to console (useful for debugging)
 */
export function logBuildInfo() {
  const info = getBuildInfo();
  console.log(`[BUILD] Version: ${info.id} | Time: ${info.timestamp} | Env: ${info.environment}`);
}
